import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { IdiomaGR } from "@sharedV11/classes/tarifaResponse/idiomaGR";
import { IdiomasInfoI18N } from "@sharedV11/classes/tarifaResponse/IdiomasInfoI18N";
import { InternetGroup } from "@sharedV11/classes/tarifaResponse/internetgroup";
import { AlertService } from "@sharedV11/services/alerts/alert/alert.service";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { ApiTokenService } from "@sharedV11/services/api/token/api-token.service";
import { EditInternetGroupService } from "@sharedV11/services/components/internetGroups/edit-internet-group.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";
import { ImageModalComponent } from "./image-modal.component";

@Component({
  selector: "app-edit-group",
  templateUrl: "./edit-group.component.html",
  styleUrls: ["./edit-group.component.scss"],
})
export class EditGroupComponent implements OnInit, AfterViewInit {

  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: string;
  @Input() modificar: boolean;

  idiomaOriginal = [];
  idiomaI18NOriginal = [];

  translation: any;
  editorListaIdiomas: Array<IdiomaGR> = [];
  editorListaInfo: Array<IdiomasInfoI18N> = [];
  idiomasApp: Array<IdiomaGR> = [];
  editInternetGroupForm: FormGroup;
  submitValidationTick = 0;

  internetgroup: InternetGroup;
  TiposReservas: any[] = [];
  EnlacesMenu: any[] = [];

  //https://www.npmjs.com/package/angular-dual-listbox
  filter = true;
  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  enlacesOriginales = [];
  source = [];
  confirmados = [];

  conectionId;
  cplist = [];

  //centros
  centrosSinAsignar = [];
  centrosAsignados = [];
  tipoCentros: any[] = [];
  //centros

 
  seosOriginales = [];
  seosSinAsignar = [];
  seosAsignados = [];
  selectedFiles: File[] = [];

  private readonly MAX_IMAGE_SIZE_KB = 300;
  private readonly MAX_IMAGE_SIZE_BYTES = this.MAX_IMAGE_SIZE_KB * 1024;

  // imagenes
  imagenPortada: any;
  sizePortada: string;
  sizePortadaKB: number | null = null;
  imagenFicha: any;
  sizeFicha: string;
  sizeFichaKB: number | null = null;
  imagenPdf: any;
  sizePdf: string;
  sizePdfKB: number | null = null;

  // flags visuales de error en imágenes
  portadaError = false;
  fichaError = false;
  pdfError = false;

  imagenPortadaOriginal: any;
  imagenFichaOriginal: any;
  imagenPdfOriginal: any;

  // flags de eliminación: permiten borrar una imagen sin afectar las otras
  portadaRemoved = false;
  fichaRemoved = false;
  pdfRemoved = false;

  EIMAGES = {
    PORTADA: 'portada',
    FICHA: 'ficha',
    PDF: 'pdf'  
  }

  constructor(
    private editInternetGroupService: EditInternetGroupService,
    private servicioAPI: ConectarApiService,
    private fb: FormBuilder,
    private translator: Translator,
    private cdRef: ChangeDetectorRef,
    private panelService: PanelService,
    private tokenService: ApiTokenService,
    private alertaService: AlertService,
    private httpErrorService: HttpErrorsService,
    private gsCentros: GlobalServicCentros,
    private snackvar_service: SnackbarInfoService,
    private dialog: MatDialog,
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngOnInit(): void {
    this.loadCentros();
    this.getEnlacesMenu();
    this.getSeos();
    this.initializeTranslate();
    this.getTipoReserva();

    this.format = {
      add: this.translation.Anadir,
      remove: this.translation.Borrar,
      all: this.translation.Todos,
      none: this.translation.Ninguno,
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };

    this.initializeFormWithoutData();
  }

  ngAfterViewInit() {
    // this.pkId="4"
    this.manageForm(this.pkId, this.mode);
  }

  async loadCentros() {
    await this.gsCentros.getCentros();
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
  }

  get formControls() {
    return this.editInternetGroupForm.controls;
  }

  ver() {}
  manageForm(pkId, mode) {
    if (mode == "I") {
      this.internetgroup = this.editInternetGroupForm.value;
      this.centrosSinAsignar = this.gsCentros.filtrarTiposCentros();
      this.loading = false;
      this.getEnlacesMenu();
      
      this.getIdiomas([], []);
      this.cdRef.detectChanges();
      this.valuedChanged();
    }
    if (pkId != null) {
      this.findinternetGroup(pkId);
    }
  }

  findinternetGroup(pkId) {
    let ClaveEmpresa = this.tokenService.getConfig("chClaveEmpresa");
    let ProyectoOnLine = this.tokenService.getConfig("chProyectoOnLine");
    let ConexionEntorno = this.tokenService.getConfig("chEntornoConexion");
    this.editInternetGroupService
      .findIternetGroupByPkId(
        pkId,
        ClaveEmpresa,
        ProyectoOnLine,
        ConexionEntorno
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (userApi) => {

          let internetgroupdata: InternetGroup = userApi.DatosResult.listaGrupoInternet[0];

          if (internetgroupdata != null) {

            await this.changeValueForm(internetgroupdata);
            this.internetgroup = this.editInternetGroupForm.value;
            this.internetgroup = internetgroupdata;
            this.loading = false;
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  async loadEntity(internetgroupdata: InternetGroup) {

     
      if (!this.gsCentros.tipoCentros?.length) {
        await this.gsCentros.getCentros();
      }

      const todos = this.gsCentros.filtrarTiposCentros() ?? [];
      this.centrosAsignados = this.gsCentros.daTiposCentros(internetgroupdata) ?? [];

      const enTodos = new Set(
        (todos as any[]).map((c) =>
          String(c?.pkId ?? c?.PkId ?? c?.Id ?? c?.id ?? "").trim()
        ).filter(Boolean)
      );
      const faltamNoTodos = this.centrosAsignados.filter((a: any) => {
        const id = String(a?.pkId ?? "").trim();
        return id.length > 0 && !enTodos.has(id);
      });
      this.centrosSinAsignar = [...todos, ...faltamNoTodos];

      const seoOriginals = this.seosSinAsignar;
      this.seosAsignados = [];
      if (internetgroupdata.SEOIds && internetgroupdata.SEOIds.length > 0)
        this.seosAsignados = internetgroupdata.SEOIds.split(",").map(id => {
          return seoOriginals.find(s => s.pkId === +id);
        });

      if (internetgroupdata.LstEnlacesMenu) {
        this.source = internetgroupdata.LstEnlacesMenu;
        this.enlacesOriginales = this.source;
      }
      else
        this.source = this.enlacesOriginales;

      this.confirmados = this.source.filter(
        (f) => f.Asignado == "1"
      );
      if (this.confirmados.length > 0) {
        this.conectionId = this.confirmados[0].ConexionId;
      }

      if (internetgroupdata.Idiomas)
      {
        this.idiomaOriginal = internetgroupdata.Idiomas;
        this.idiomaI18NOriginal = internetgroupdata.IdiomasInfoI18N;
      }

      this.getIdiomas(this.idiomaOriginal, this.idiomaI18NOriginal);
      this.getListaEnlaces();

      if (internetgroupdata.Imagen)
        this.imagenPortadaOriginal = internetgroupdata.Imagen;

      if (internetgroupdata.ImagenDetalle)
        this.imagenFichaOriginal = internetgroupdata.ImagenDetalle;

      // PDF: debemos comprobar el propio campo ImagenPDF, no ImagenDetalle
      if (internetgroupdata.ImagenPDF)
        this.imagenPdfOriginal = internetgroupdata.ImagenPDF;

      // al cargar desde API, ninguna imagen está "borrada" por el usuario
      this.portadaRemoved = false;
      this.fichaRemoved = false;
      this.pdfRemoved = false;

      //imagenes
      this.loadImage(this.imagenPortadaOriginal, this.EIMAGES.PORTADA);
      this.loadImage(this.imagenFichaOriginal, this.EIMAGES.FICHA);
      this.loadImage(this.imagenPdfOriginal, this.EIMAGES.PDF);

      this.cdRef.detectChanges();

  }

  funcionEncript(json) {
    const clavePrivada = "3ñdlfjdfksdffffs%i2343424kjfdsü&/@#$A·";
    let final = "";
    for (let index = 1; index <= json.length; index++) {
      const tokenMio = this.Mid(json, index, 1);
      const codigo = this.Mid(
        clavePrivada,
        ((index - 1) % clavePrivada.length) + 1,
        1
      );
      // tslint:disable-next-line:no-bitwise
      const a = (this.Asc(codigo) ^ this.Asc(tokenMio)).toString(16);
      final = final + this.Right("0" + a, 2);
    }
    return final;
  }

  Mid(strMid, intBeg, intEnd) {
    if (strMid === null || strMid === "" || intBeg < 0) {
      return "";
    }
    intBeg -= 1;
    if (intEnd === null || intEnd === "") {
      return strMid.substr(intBeg);
    } else {
      return strMid.substr(intBeg, intEnd);
    }
  }

  Chr(num) {
    const res = String.fromCharCode(num);
    return res;
  }

  Asc(str) {
    return str.charCodeAt(0);
  }

  Right(str, n) {
    if (n <= 0) {
      return "";
    } else if (n > String(str).length) {
      return str;
    } else {
      const iLen = String(str).length;
      return String(str).substring(iLen, iLen - n);
    }
  }

  private idTipoOperacionFromApi(ig: InternetGroup | any): string {
    const v = ig?.IdTipoOperacion ?? ig?.idTipoOperacion;
    if (v === null || v === undefined || String(v).trim() === "") {
      return "0";
    }
    return String(v).trim();
  }

  initializeFormWithData(ig: InternetGroup) {
    this.editInternetGroupForm = this.fb.group({
      pkId: [ig.pkId],
      Nombre: [ig.Nombre],
      Idioma: [ig.Idioma],
      Maximo: [ig.Maximo],
      Minimo: [ig.Minimo],
      TipoReservaId: [ig.TipoReservaId],
      ValidarGratuitas: [ig.ValidarGratuitas],
      idTipoOperacion: [this.idTipoOperacionFromApi(ig)],
      Orden: [ig.Orden],
      Descripcion: [ig.Descripcion],
      Relevante: [""],
      ///images
      // Imagen: [ig.Imagen],
      // ImageDetalle: [ig.ImagenDetalle],
      // ImagenPDF: [ig.ImagenPDF],
    });
  }

  async changeValueForm(ig: InternetGroup) {
    this.formControls["pkId"].setValue(ig.pkId);
    this.formControls["Nombre"].setValue(ig.Nombre);
    this.formControls["Idioma"].setValue(ig.Idioma);
    this.formControls["Maximo"].setValue(ig.Maximo);
    this.formControls["Minimo"].setValue(ig.Minimo);
    this.formControls["TipoReservaId"].setValue(ig.TipoReservaId);
    this.formControls["ValidarGratuitas"].setValue(ig.ValidarGratuitas);
    this.formControls["idTipoOperacion"].setValue(this.idTipoOperacionFromApi(ig));
    this.formControls["Orden"].setValue(ig.Orden);
    this.formControls["Descripcion"].setValue(ig.Descripcion);
    //this.formControls["Prefijo"].setValue(ig.Prefijo)
    this.formControls["Relevante"].setValue(ig.Relevante);

    // this.formControls["Imagen"].setValue(ig.Imagen);
    // this.formControls["ImageDetalle"].setValue(ig.ImagenDetalle);
    // this.formControls["ImagenPDF"].setValue(ig.ImagenPDF);

    await this.loadEntity(ig);
  }

  initializeFormWithoutData() {
    this.editInternetGroupForm = this.fb.group({
      pkId: [""],
      Nombre: ["", Validators.required],
      Idioma: [""],
      Descripcion: [""],
      Orden: [""],
      Maximo: [""],
      Minimo: [""],
      TipoReservaId: ["", Validators.required],
      ValidarGratuitas: [""],
      idTipoOperacion: ["0"],
      CentrosIds: [""],
      // Prefijo:[""]
      Relevante: [""],
    });
  }

  stringToBoolean(value) {
    if (typeof value !== "boolean") {
      if (value.toLowerCase() == "true") {
        value = true;
      } else {
        value = false;
      }
    }
    return value;
  }

  getTipoReserva() {
    this.servicioAPI.getTiposReserva().subscribe(
      (TiposReservas) => {
        this.TiposReservas = TiposReservas.DatosResult.listaTipoReserva;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  getSeos() {
    const that = this;
    this.servicioAPI.getSchemas(null,null).subscribe(
      (response) => {
        const schemas = response.datosResult.listado.map((item) => ({
          pkId: item.pkId,
          Nombre: item.nombre,
        }));
        that.seosSinAsignar = schemas;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  getEnlacesMenu() {
    this.servicioAPI.getEnlacesMenu().subscribe(
      (EnlacesMenu) => {
        this.enlacesOriginales = EnlacesMenu.DatosResult.LstEnlacesMenu;
        this.source = this.enlacesOriginales;
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  getListaEnlaces() {
    this.confirmados.forEach((c) => {
      var cplistlang = [];
      c.ListUrlVentaOnline.forEach((l) => {
        cplistlang.push({
          idioma: l.idoma,
          urlparams: "",
          url: l.UrlVentaOnline,
          grupo: this.translation.Copiar + " " + c["Nombre"],
        });
      });
      this.cplist.push(cplistlang);
    });
  }

  getIdiomas(idiomasgrupo, idiomasInfoI18N) {

    // Limpar arrays antes de adicionar novos elementos para evitar duplicações
    this.editorListaIdiomas = [];
    this.editorListaInfo = [];
    this.idiomasApp = [];

    this.servicioAPI.getIdiomas().subscribe(
      (losidiomas) => {

        losidiomas.DatosResult.ListaIdiomas.map((idioma) => {
          let idiomaselect = new IdiomaGR();
          idiomaselect.CodIdioma = idioma.CodIdioma;
          idiomaselect.Nombre = idioma.Nombre;
          this.idiomasApp.push(idiomaselect);

          let idiomaObj = idiomasgrupo.find(
            (i) => i.CodIdioma == idioma.CodIdioma
          );

          this.editorListaIdiomas.push(idioma);

          // this.editInternetGroupForm.addControl(
          //   "nombre" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Nombre : "")
          // );
          // this.editInternetGroupForm.addControl(
          //   "descripcion" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Descripcion : "")
          // );
          // this.editInternetGroupForm.addControl(
          //   "descripcion1" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Descripcion1 : "")
          // );
          // this.editInternetGroupForm.addControl(
          //   "descripcion2" + idioma.CodIdioma,
          //   new FormControl(idiomaObj ? idiomaObj.Descripcion2 : "")
          // );
          // Verificar se o idioma já existe antes de adicionar
          if (!this.editorListaIdiomas.find(i => i.CodIdioma === idioma.CodIdioma)) {
            this.editorListaIdiomas.push(idioma);
          }

          this.addNewControl("nombre", idioma.CodIdioma, idiomaObj, "Nombre");
          this.addNewControl("descripcion", idioma.CodIdioma, idiomaObj, "Descripcion");
          this.addNewControl("descripcion1", idioma.CodIdioma, idiomaObj, "Descripcion1");
          this.addNewControl("descripcion2", idioma.CodIdioma, idiomaObj, "Descripcion2");


          //informacion venta online

          let idiomaObjInfo = idiomasInfoI18N.find((i) => i.CodIdioma == idioma.CodIdioma);

          let idiomaInfo = new IdiomasInfoI18N();
          idiomaInfo.CodIdioma = idioma.CodIdioma;
          idiomaInfo.Nombre = idioma.Nombre;
          idiomaInfo.Titulo = idiomaObjInfo ? idiomaObjInfo.Titulo : "";
          idiomaInfo.Parrafo1 = idiomaObjInfo ? idiomaObjInfo.Parrafo1 : "";
          idiomaInfo.Parrafo2 = idiomaObjInfo ? idiomaObjInfo.Parrafo2 : "";
          // idiomaInfo.Parrafo3 = idiomaObjInfo ? idiomaObjInfo.Parrafo3 : "";
          idiomaInfo.Horario1 = idiomaObjInfo ? idiomaObjInfo.Horario1 : "";
          idiomaInfo.Horario2 = idiomaObjInfo ? idiomaObjInfo.Horario2 : "";
          idiomaInfo.Horario3 = idiomaObjInfo ? idiomaObjInfo.Horario3 : "";
          idiomaInfo.Horario4 = idiomaObjInfo ? idiomaObjInfo.Horario4 : "";
          idiomaInfo.Tipo = idiomaObjInfo ? idiomaObjInfo.Tipo : "";
          idiomaInfo.TipoPublico = idiomaObjInfo ? idiomaObjInfo.TipoPublico : "";
          idiomaInfo.MetaDescription = idiomaObjInfo ? idiomaObjInfo.MetaDescription : "";
          // Usar os mesmos nomes de propriedades que o JSON da API devolve
          // para garantir que os valores persistidos se reflitam corretamente no UI.
          // A API devolve "Copyright" e "URLExterna".
          idiomaInfo.Copyright = idiomaObjInfo ? idiomaObjInfo.Copyright : "";
          idiomaInfo.TextoAmigable = idiomaObjInfo ? idiomaObjInfo.TextoAmigable : "";
          idiomaInfo.Ubicacion = idiomaObjInfo ? idiomaObjInfo.Ubicacion : "";
          idiomaInfo.URLExterna = idiomaObjInfo ? idiomaObjInfo.URLExterna : "";
          idiomaInfo.Tipo = idiomaObjInfo ? idiomaObjInfo.Tipo : "";
          idiomaInfo.TipoPublico = idiomaObjInfo ? idiomaObjInfo.TipoPublico : "";
          this.editorListaInfo.push(idiomaInfo);
          idiomaInfo.URLExterna = idiomaObjInfo ? idiomaObjInfo.UrlExterna : "";
          
          // Verificar se o idioma já existe antes de adicionar
          if (!this.editorListaInfo.find(i => i.CodIdioma === idioma.CodIdioma)) {
            this.editorListaInfo.push(idiomaInfo);
          }

          this.addNewControl("titulo", idioma.CodIdioma, idiomaObjInfo, "Titulo");
          this.addNewControl("parrafo1", idioma.CodIdioma, idiomaObjInfo, "Parrafo1");
          this.addNewControl("parrafo2", idioma.CodIdioma, idiomaObjInfo, "Parrafo2");
          // this.addNewControl("parrafo3", idioma.CodIdioma, idiomaObjInfo, "Parrafo3");
          this.addNewControl("horario1", idioma.CodIdioma, idiomaObjInfo, "Horario1");
          this.addNewControl("horario2", idioma.CodIdioma, idiomaObjInfo, "Horario2");
          this.addNewControl("horario3", idioma.CodIdioma, idiomaObjInfo, "Horario3");
          this.addNewControl("horario4", idioma.CodIdioma, idiomaObjInfo, "Horario4");
          this.addNewControl("tipoVisita", idioma.CodIdioma, idiomaObjInfo, "Tipo");
          this.addNewControl("tipoPublico", idioma.CodIdioma, idiomaObjInfo, "TipoPublico");
          this.addNewControl("metaDescription", idioma.CodIdioma, idiomaObjInfo, "MetaDescription");
          this.addNewControl("copyright", idioma.CodIdioma, idiomaObjInfo, "Copyright");
          this.addNewControl("textoAmigable", idioma.CodIdioma, idiomaObjInfo, "TextoAmigable");
          this.addNewControl("ubicacion", idioma.CodIdioma, idiomaObjInfo, "Ubicacion");
          this.addNewControl("urlexterna", idioma.CodIdioma, idiomaObjInfo, "URLExterna");   
          
        });

        this.internetgroup = this.editInternetGroupForm.value;
        this.valuedChanged();
      },
      (error) => {
        this.httpErrorService.identificarErrores(error);
      }
    );
  }

  addNewControl(ctrName: string, idioma: string, idiomaObjInfo: IdiomasInfoI18N, field:string) {
    let control = ctrName + idioma;
    let values = idiomaObjInfo ? idiomaObjInfo[field]: "";

    if (!this.editInternetGroupForm.get(control)) {
     
      this.editInternetGroupForm.addControl(control, new FormControl(values));
    }

    if (this.editInternetGroupForm.get(control)) {
      const obj = {};
      obj[control] = values;
      this.editInternetGroupForm.patchValue(obj);
    }
  }

  submit() {
    this.submitValidationTick++;
    this.editInternetGroupForm.markAllAsTouched();
    this.syncInputFilterFromDom("TipoReservaId");

    if (this.editInternetGroupForm.invalid) {
      this.alertaService.error(this.mensajeValidacionCamposRequeridos());
      this.snackvar_service.openSnackBar(
        this.mensajeValidacionCamposRequeridos(),
        "",
        "red-snackbar"
      );
      return;
    }

    let internetgroup: InternetGroup = this.editInternetGroupForm.value;


    internetgroup.Idiomas = [];
    internetgroup.IdiomasInfoI18N = [];
    
    const idiomasUnicos = Array.from(
      new Map(this.editorListaIdiomas.map(item => [item.CodIdioma, item])).values()
    );
    
    idiomasUnicos.forEach((i) => {
      let enIdioma: IdiomaGR = new IdiomaGR();
      enIdioma.CodIdioma = i.CodIdioma;
      enIdioma.Nombre = internetgroup["nombre" + i.CodIdioma];
      enIdioma.Descripcion = internetgroup["descripcion" + i.CodIdioma];
      enIdioma.Descripcion1 = internetgroup["descripcion1" + i.CodIdioma];
      enIdioma.Descripcion2 = internetgroup["descripcion2" + i.CodIdioma];
      internetgroup.Idiomas.push(enIdioma);

      let enInfoVO: IdiomasInfoI18N = new IdiomasInfoI18N();
      enInfoVO.CodIdioma = i.CodIdioma;
      enInfoVO.Titulo = internetgroup["titulo" + i.CodIdioma];
      enInfoVO.Parrafo1 = internetgroup["parrafo1" + i.CodIdioma];
      enInfoVO.Parrafo2 = internetgroup["parrafo2" + i.CodIdioma];
      enInfoVO.Horario1 = internetgroup["horario1" + i.CodIdioma];
      enInfoVO.Horario2 = internetgroup["horario2" + i.CodIdioma];
      enInfoVO.Horario3 = internetgroup["horario3" + i.CodIdioma];
      enInfoVO.Horario4 = internetgroup["horario4" + i.CodIdioma];
      enInfoVO.Tipo = internetgroup["tipoVisita" + i.CodIdioma];
      enInfoVO.TipoPublico = internetgroup["tipoPublico" + i.CodIdioma];
      enInfoVO.MetaDescription = internetgroup["metaDescription" + i.CodIdioma];
      enInfoVO.Copyright = internetgroup["copyright" + i.CodIdioma];
      enInfoVO.TextoAmigable = internetgroup["textoAmigable" + i.CodIdioma];
      enInfoVO.Copyright = internetgroup["copyright" + i.CodIdioma];
      enInfoVO.URLExterna = internetgroup["urlexterna" + i.CodIdioma];
      enInfoVO.Ubicacion = internetgroup["ubicacion" + i.CodIdioma];
      internetgroup.IdiomasInfoI18N.push(enInfoVO);
    });

    let enlacesmenu = [];
    if (this.confirmados.length == 0) {
      enlacesmenu.push({ pkId: "", ConexionId: this.conectionId });
    }
    this.confirmados.forEach((c) => {
      enlacesmenu.push({ pkId: c.pkId, ConexionId: c.ConexionId });
    });
    //imagenes
    // internetgroup.Imagen = this.imagenPortada;
    // internetgroup.ImagenDetalle = this.imagenFicha;
    // internetgroup.ImagenPDF = this.imagenPdf;

    internetgroup.EnlacesMenu = enlacesmenu;

    // agregados
    internetgroup.CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(
      this.centrosAsignados
    );
    if (this.seosAsignados.length > 0)
      internetgroup.SEOIds = this.seosAsignados.map(s => s.pkId).join(",");

    // imágenes:
    // - si el usuario pulsa "Quitar": enviar null SOLO para esa imagen
    // - si no toca una imagen: preservar el valor original (evita que el backend borre campos no modificados)
    internetgroup.Imagen = this.portadaRemoved
      ? null
      : (this.imagenPortada && this.imagenPortada.length > 0
          ? this.imagenPortada
          : (this.imagenPortadaOriginal && this.imagenPortadaOriginal.length > 0 ? this.imagenPortadaOriginal : null));

    internetgroup.ImagenDetalle = this.fichaRemoved
      ? null
      : (this.imagenFicha && this.imagenFicha.length > 0
          ? this.imagenFicha
          : (this.imagenFichaOriginal && this.imagenFichaOriginal.length > 0 ? this.imagenFichaOriginal : null));

    internetgroup.ImagenPDF = this.pdfRemoved
      ? null
      : (this.imagenPdf && this.imagenPdf.length > 0
          ? this.imagenPdf
          : (this.imagenPdfOriginal && this.imagenPdfOriginal.length > 0 ? this.imagenPdfOriginal : null));

    internetgroup.Relevante = internetgroup["Relevante"] ? 1 : 0;

    const rawTipoOp = this.editInternetGroupForm.get("idTipoOperacion")?.value;
    internetgroup.idTipoOperacion =
      rawTipoOp === null ||
      rawTipoOp === undefined ||
      String(rawTipoOp).trim() === ""
        ? "0"
        : String(rawTipoOp).trim();
    delete (internetgroup as any).IdTipoOperacion;

    idiomasUnicos.forEach((i) => {
      delete internetgroup["nombre" + i.CodIdioma];
      delete internetgroup["descripcion" + i.CodIdioma];
      delete internetgroup["descripcion1" + i.CodIdioma];
      delete internetgroup["descripcion2" + i.CodIdioma];
      delete internetgroup["titulo" + i.CodIdioma];
      delete internetgroup["parrafo1" + i.CodIdioma];
      delete internetgroup["parrafo2" + i.CodIdioma];
      delete internetgroup["horario1" + i.CodIdioma];
      delete internetgroup["horario2" + i.CodIdioma];
      delete internetgroup["horario3" + i.CodIdioma];
      delete internetgroup["horario4" + i.CodIdioma];
      delete internetgroup["tipoVisita" + i.CodIdioma];
      delete internetgroup["tipoPublico" + i.CodIdioma];
      delete internetgroup["metaDescription" + i.CodIdioma];
      delete internetgroup["copyright" + i.CodIdioma];
      delete internetgroup["textoAmigable" + i.CodIdioma];
      delete internetgroup["ubicacion" + i.CodIdioma];
      delete internetgroup["urlexterna" + i.CodIdioma];
    });

    this.removeUnnecessaryLanguageAttributes(internetgroup);

    this.manageApi(internetgroup, this.mode);
  }

  private mensajeValidacionCamposRequeridos(): string {
    return (
      this.translation?.FaltanCamposRequeridos ||
      this.translation?.FaltanCamposObligatorios ||
      this.translation?.ValidarCampos ||
      "Faltan Campos Obligatorios"
    );
  }

  get textoCampoRequerido(): string {
    return (
      this.translation?.CampoRequerido ||
      this.translation?.CampoObligatorio ||
      "Campo requerido"
    );
  }

  validateFields(field: string): boolean {
    const ctrl = this.editInternetGroupForm.get(field);
    return !!(ctrl && ctrl.invalid && (ctrl.dirty || ctrl.touched));
  }

  getErrorMessage(field: string): string {
    const ctrl = this.editInternetGroupForm.get(field);
    if (ctrl?.errors?.required) {
      return `* ${this.textoCampoRequerido}`;
    }
    return "";
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  save() {
    this.loading = false;
    this.panelService.setSavePanel(null);
  }
  discard() {
    void this.changeValueForm(this.internetgroup);
  }

  manageApi(internetgroup: InternetGroup, mode) {
    this.loading = true;
    // internetgroup.CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(
    //   this.centrosAsignados
    // );
    // if (this.seosAsignados.length > 0)
    //   internetgroup.SEOIds = this.seosAsignados.map(s => s.pkId).join(",");

    // internetgroup.Imagen = this.imagenPortada &&  this.imagenPortada.length > 0 ? this.imagenPortada : null;
    // internetgroup.ImageDetalle = this.imagenFicha && this.imagenFicha.length > 0 ? this.imagenFicha : null;
    // internetgroup.ImagenPDF = this.imagenPdf &&  this.imagenPdf.length > 0 ? this.imagenPdf : null;

    this.insertDataInObj();
    switch (mode) {
      case "I":
        internetgroup.pkId = "0";
        this.InsGrupoInternet(internetgroup);
        break;
      case "U":
        this.UpdGrupoInternet(internetgroup);
        break;
      case "D":
        internetgroup.pkId = "0";
        this.InsGrupoInternet(internetgroup);
        break;
      default:
        break;
    }
  }

  UpdGrupoInternet(internetgroup) {
    this.insUpdGrupoInternet(internetgroup, "U");
  }

  InsGrupoInternet(internetgroup) {
    this.insUpdGrupoInternet(internetgroup, "I");
  }

  /** Insertar y actualización unificados en InsertarActualizarCustomanGruposInternet */
  private insUpdGrupoInternet(internetgroup: InternetGroup, mode: "I" | "U") {
    this.editInternetGroupService
      .insUpdGruposInternet(internetgroup, mode)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (response) => {
          if (response?.DatosResult != null) {
            this.save();
            this.alertaService.success("Datos Guardados Correctamente");
            this.destroy();
          } else {
            this.loading = false;
            const msg =
              response?.Mensajes?.[0]?.DescripcionMensaje ?? "Error";
            if (mode === "I") {
              this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
            } else {
              this.alertaService.error(msg);
            }
          }
        },
        (error) => {
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  cambiaNombre(evento, idioma) {
    this.editorListaIdiomas.find((x) => x.CodIdioma == idioma).Nombre = evento;
    //
  }
  cambiaDescripcion(evento, idioma) {
    this.editorListaIdiomas.find((x) => x.CodIdioma == idioma).Descripcion =
      evento;
    //
  }

  valuedChanged() {
    this.editInternetGroupForm.valueChanges.subscribe((value) => {
      if (this.internetgroup != null) {
        this.panelService.setDiscardChanges(false);
        if (JSON.stringify(value) === JSON.stringify(this.internetgroup)) {
          this.panelService.setDiscardChanges(true);
        }
      }
    });
  }

  insertDataInForm() {
    if (<HTMLInputElement>document.getElementById("TipoReservaId-hidden"))
      this.editInternetGroupForm
        .get("TipoReservaId")
        .setValue(
          (<HTMLInputElement>document.getElementById("TipoReservaId-hidden"))
            .value
        );
  }
  insertDataInObj() {
    this.internetgroup.TipoReservaId = (<HTMLInputElement>(
      document.getElementById("TipoReservaId-hidden")
    )).value;
  }
  closeInputFilter(eventValues) {
    this.syncInputFilterFromChild(eventValues);
  }

  syncInputFilterFromChild(eventValues: { name: string; value: any }) {
    if (eventValues?.name) {
      const ctrl = this.editInternetGroupForm.get(eventValues.name);
      if (!ctrl) {
        return;
      }

      let value = eventValues.value;
      if (value === "" || value === "-1" || value === undefined) {
        value = null;
      }
      ctrl.setValue(value);
      ctrl.markAsTouched();
      ctrl.updateValueAndValidity({ emitEvent: true });
      return;
    }

    this.insertDataInForm();
  }

  private syncInputFilterFromDom(controlName: string): void {
    const hidden = document.getElementById(`${controlName}-hidden`) as HTMLInputElement;
    if (!hidden) {
      return;
    }
    const ctrl = this.editInternetGroupForm.get(controlName);
    if (!ctrl) {
      return;
    }
    const value = hidden.value && hidden.value !== "-1" ? hidden.value : null;
    ctrl.setValue(value);
    ctrl.markAsTouched();
    ctrl.updateValueAndValidity({ emitEvent: true });
  }

  private setRemovedFlag(filename: string, removed: boolean): void {
    switch (filename) {
      case this.EIMAGES.PORTADA:
        this.portadaRemoved = removed;
        break;
      case this.EIMAGES.FICHA:
        this.fichaRemoved = removed;
        break;
      case this.EIMAGES.PDF:
        this.pdfRemoved = removed;
        break;
    }
  }

  removeImage(filename: string): void {
    this.setRemovedFlag(filename, true);
    // limpia preview + tamaños sin tocar los "originales" (sirven para discard / fallback)
    this.setImageAndSize("", filename, "");
    this.cdRef.detectChanges();
  }

  onFileSelected(event: any, filename: string) {
    const file: File = event?.target?.files?.[0];

    if (!file) {
      return;
    }

    // si el usuario selecciona una nueva imagen, ya no está marcada como "borrada"
    this.setRemovedFlag(filename, false);

    // Validación de formato: solo se permiten archivos JPG
    const allowedTypes = ['image/jpeg', 'image/jpg'];
    const fileExtension = file.name.toLowerCase().split('.').pop();
    const isJpg = allowedTypes.includes(file.type.toLowerCase()) || 
                  fileExtension === 'jpg' || 
                  fileExtension === 'jpeg';

    if (!isJpg) {
      this.markImageError(filename);

      const message =
        (this.translation?.ImagenErrorFormato) ||
        `El formato de imagen debe ser JPG. Por favor, seleccione otra imagen.`;

      this.snackvar_service.openSnackBar(
        message,
        "",
        "red-snackbar"
      );

      // reseteamos el input para que pueda volver a seleccionar
      event.target.value = "";
      return;
    }

    // Validación de peso máximo (en KB)
    if (file.size > this.MAX_IMAGE_SIZE_BYTES) {
      this.markImageError(filename);

      const message =
        (this.translation?.ImagenErrorPeso &&
          this.translation.ImagenErrorPeso.replace(
            "{maxSize}",
            this.MAX_IMAGE_SIZE_KB.toString()
          )) ||
        `El peso máximo de la imagen es de ${this.MAX_IMAGE_SIZE_KB}KB. Por favor, seleccione otra imagen.`;

      this.snackvar_service.openSnackBar(
        message,
        "",
        "red-snackbar"
      );

      // reseteamos el input para que pueda volver a seleccionar
      event.target.value = "";
      return;
    }

    // guardamos el peso de la imagen en KB para mostrarlo en la UI
    const sizeKB = Math.round(file.size / 1024);
    switch (filename) {
      case this.EIMAGES.PORTADA:
        this.sizePortadaKB = sizeKB;
        break;
      case this.EIMAGES.FICHA:
        this.sizeFichaKB = sizeKB;
        break;
      case this.EIMAGES.PDF:
        this.sizePdfKB = sizeKB;
        break;
    }

    //Show image preview
    const reader = new FileReader();
    reader.onload = (loadEvent: any) => {
      this.loadImage(loadEvent.target.result, filename);
    };
    reader.readAsDataURL(file);
  }

  loadImage(source: any, filename: string) {
    // no tenemos imagen
    if (source) {
      this.calculateImageSizeKB(source, filename);

      const img = new Image();
      img.src = source;
      img.onload = () => {
        const width = img.width;
        const height = img.height;
        this.setImageAndSize(source, filename, width + "x" + height);
      };
    } else {
      this.setImageAndSize("", filename, "");
    }
  }

  setImageAndSize(source: any, filename: string, size: string) {
    switch (filename) {
      case this.EIMAGES.PORTADA:
        this.sizePortada = size;
        this.imagenPortada = source;
        if (!source) {
          this.sizePortadaKB = null;
        }
        break;
      case this.EIMAGES.FICHA:
        this.sizeFicha = size;
        this.imagenFicha = source;
        if (!source) {
          this.sizeFichaKB = null;
        }
        break;
      case this.EIMAGES.PDF:
        this.sizePdf = size;
        this.imagenPdf = source;
        if (!source) {
          this.sizePdfKB = null;
        }
        break;
    }
  }

  private calculateImageSizeKB(source: any, filename: string): void {
    switch (filename) {
      case this.EIMAGES.PORTADA:
        if (this.sizePortadaKB !== null) return;
        break;
      case this.EIMAGES.FICHA:
        if (this.sizeFichaKB !== null) return;
        break;
      case this.EIMAGES.PDF:
        if (this.sizePdfKB !== null) return;
        break;
    }

    if (typeof source === 'string' && source.startsWith('data:')) {
  
      const base64Data = source.split(',')[1];
      if (base64Data) {
    
        const sizeInBytes = (base64Data.length * 3) / 4;
        const sizeKB = Math.round(sizeInBytes / 1024);
        this.setImageSizeKB(filename, sizeKB);
      }
    } else if (typeof source === 'string' && (source.startsWith('http://') || source.startsWith('https://'))) {
    
      fetch(source, { method: 'HEAD' })
        .then(response => {
          const contentLength = response.headers.get('content-length');
          if (contentLength) {
            const sizeKB = Math.round(parseInt(contentLength, 10) / 1024);
            this.setImageSizeKB(filename, sizeKB);
          } else {
            fetch(source)
              .then(res => res.blob())
              .then(blob => {
                const sizeKB = Math.round(blob.size / 1024);
                this.setImageSizeKB(filename, sizeKB);
              })
              .catch(() => {
                
              });
          }
        })
        .catch(() => {
        
        });
    }
  }

 
  removeUnnecessaryLanguageAttributes(internetgroup: InternetGroup) {
  
    const idiomas = ['es-ES', 'ca', 'en-GB', 'fr-FR', 'nl-NL', 'pt-PT', 'de-DE', 'es', 'en', 'fr', 'nl', 'pt', 'de'];
    const atributos = [
      'nombre', 'descripcion', 'descripcion1', 'descripcion2',
      'titulo', 'parrafo1', 'parrafo2', 'parrafo3',
      'horario1', 'horario2', 'horario3', 'horario4',
      'metaDescription', 'copyright', 'copyRight',
      'textoAmigable', 'ubicacion', 'urlexterna', 'url'
    ];


    idiomas.forEach(idioma => {
      atributos.forEach(atributo => {
        
        const variations = [
          atributo + idioma,
          atributo + idioma.toLowerCase(),
          atributo + idioma.toUpperCase()
        ];
        
        variations.forEach(key => {
          if (internetgroup.hasOwnProperty(key)) {
            delete internetgroup[key];
          }
        });
      });
    });

    
    Object.keys(internetgroup).forEach(key => {
    
      idiomas.forEach(idioma => {
        if (key.endsWith(idioma) || key.endsWith(idioma.toLowerCase()) || key.endsWith(idioma.toUpperCase())) {
          
          const baseKey = key.substring(0, key.length - idioma.length);
          if (atributos.some(attr => baseKey === attr || baseKey === attr.toLowerCase() || baseKey === attr.toUpperCase())) {
            delete internetgroup[key];
          }
        }
      });
    });
  }

  private setImageSizeKB(filename: string, sizeKB: number): void {
    switch (filename) {
      case this.EIMAGES.PORTADA:
        this.sizePortadaKB = sizeKB;
        break;
      case this.EIMAGES.FICHA:
        this.sizeFichaKB = sizeKB;
        break;
      case this.EIMAGES.PDF:
        this.sizePdfKB = sizeKB;
        break;
    }
    this.cdRef.detectChanges();
  }

  private markImageError(filename: string): void {
    switch (filename) {
      case this.EIMAGES.PORTADA:
        this.portadaError = true;
        break;
      case this.EIMAGES.FICHA:
        this.fichaError = true;
        break;
      case this.EIMAGES.PDF:
        this.pdfError = true;
        break;
    }

    setTimeout(() => {
      this.portadaError = false;
      this.fichaError = false;
      this.pdfError = false;
    }, 5000);
  }

  openImageModal(imageSrc: string, imageSize: string, imageTitle: string, imageWeightKB: number): void {
    const dialogRef = this.dialog.open(ImageModalComponent, {
      width: '90vw',
      maxWidth: '1200px',
      height: '90vh',
      panelClass: 'image-modal-container',
      data: { imageSrc, imageSize, imageTitle, imageWeightKB }
    });
  }

}
